import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export default function AdminRoute() {
    const { user } = useContext(AuthContext);

    if (!user) return <Navigate to="/login" />;

    if (user.role !== "admin") {
        return <Navigate to="/" />;
    }

    return <Outlet />;
}
